document.addEventListener('DOMContentLoaded', function () {

  /* ─────────────────────────────────────────────────────────────
     EXISTING REFS (unchanged)
  ───────────────────────────────────────────────────────────── */
  const bar      = document.getElementById('nk-floating-search');
  const form     = document.getElementById('nk-floating-search-form');
  const input    = document.getElementById('nk-floating-search-input');
  const closeBtn = document.getElementById('nk-floating-search-close');
  if (!bar || !form || !input || !closeBtn) return;

  /* ─────────────────────────────────────────────────────────────
     NEW REFS (typewriter)
  ───────────────────────────────────────────────────────────── */
  const ghost  = document.getElementById('nk-tw-ghost');
  const twText = document.getElementById('nk-tw-text');

  /* ─────────────────────────────────────────────────────────────
     TYPEWRITER CONFIG
  ───────────────────────────────────────────────────────────── */
  const PHRASES = [
    "Gift for a 7-year-old boy who loves Thor...",
    "Sarcastic notepad for an office friend...",
    "Mandala and boho design products for a Barbie fan...",
    "Premium Pushpa fandom merchandise...",
    "A thoughtful custom board game for family night...",
    "Custom dynamic novel starring my daughter...",
    "Studio-grade canvas prints of mountain landscapes...",
    "Elegant and minimalist accessories for mom...",
    "Funny personalized coffee mug for my boss...",
    "High-quality cotton tees with custom pet portraits...",
    "Premium boutique gifts under \u20B92000...",
    "Sci-fi themed desk accessories for my workspace...",
    "Personalized leather travel wallet with initials...",
    "Vintage style travel posters for the living room...",
    "Aesthetic desk setup items for remote work..."
  ];

  const TYPE_SPEED       = 50;    // ms per char typed
  const DELETE_SPEED     = 30;    // ms per char deleted
  const PAUSE_FULL       = 2500;  // ms pause after full phrase
  const PAUSE_EMPTY      = 200;   // ms pause before next phrase
  const AUTO_EXPAND_MS   = 3000;  // ms idle before auto-expand

  /* ─────────────────────────────────────────────────────────────
     PILL / EXPAND STATE
  ───────────────────────────────────────────────────────────── */
  let isExpanded  = false; // starts as pill
  let isFocused   = false;
  let phraseIdx   = 0;
  let charIdx     = 0;
  let isTyping    = true;
  let twTimer     = null;
  let autoTimer   = null;
  let lastScrollY = window.scrollY;

  /* ── Collapse to pill ── */
  function collapse() {
    if (!isExpanded) return;
    isExpanded = false;
    isFocused  = false;
    bar.classList.add('is-pill');
    stopTW();
    twText.textContent = '';
    ghost.style.display = '';
    input.classList.remove('nk-input-active');
    input.blur();
    input.value = '';
    scheduleAutoExpand();
  }

  /* ── Expand to full bar ── */
  function expand() {
    if (isExpanded) return;
    isExpanded = true;
    bar.classList.remove('is-pill');
    bar.classList.remove('is-hidden'); // respect existing hidden logic
    startTW();
  }

  /* ── Auto-expand after idle ── */
  function scheduleAutoExpand() {
    clearTimeout(autoTimer);
    autoTimer = setTimeout(function () {
      if (!isExpanded) expand();
    }, AUTO_EXPAND_MS);
  }

  /* ─────────────────────────────────────────────────────────────
     SCROLL DETECTION
  ───────────────────────────────────────────────────────────── */
  window.addEventListener('scroll', function () {
    const y     = window.scrollY;
    const delta = y - lastScrollY;
    lastScrollY = y;

    // ANY scroll → collapse to pill and restart 3s idle timer
    if (Math.abs(delta) > 4 && isExpanded && !isFocused) {
      collapse();
    }
  }, { passive: true });

  /* ─────────────────────────────────────────────────────────────
     TYPEWRITER ENGINE
  ───────────────────────────────────────────────────────────── */
  function startTW() {
    stopTW();
    charIdx  = 0;
    isTyping = true;
    tick();
  }

  function stopTW() {
    clearTimeout(twTimer);
  }

  function tick() {
    if (isFocused) return;
    const phrase = PHRASES[phraseIdx];

    if (isTyping) {
      twText.textContent = phrase.slice(0, charIdx);
      if (charIdx < phrase.length) {
        charIdx++;
        twTimer = setTimeout(tick, TYPE_SPEED);
      } else {
        twTimer = setTimeout(function () {
          isTyping = false;
          tick();
        }, PAUSE_FULL);
      }
    } else {
      if (charIdx > 0) {
        charIdx--;
        twText.textContent = phrase.slice(0, charIdx);
        twTimer = setTimeout(tick, DELETE_SPEED);
      } else {
        phraseIdx = (phraseIdx + 1) % PHRASES.length;
        isTyping  = true;
        twTimer   = setTimeout(tick, PAUSE_EMPTY);
      }
    }
  }

  /* ─────────────────────────────────────────────────────────────
     FOCUS INPUT (pauses typewriter, shows real keyboard)
  ───────────────────────────────────────────────────────────── */
  function focusInput() {
    isFocused = true;
    stopTW();
    twText.textContent = '';
    ghost.style.display = 'none';
    input.classList.add('nk-input-active');
    input.focus();
  }

  /* ─────────────────────────────────────────────────────────────
     CLICK ON BAR
  ───────────────────────────────────────────────────────────── */
  bar.addEventListener('click', function (e) {
    // collapsed → expand
    if (!isExpanded) {
      clearTimeout(autoTimer);
      expand();
      return;
    }
    // don't intercept button clicks
    if (e.target.closest('.nk-floating-search__button, .nk-floating-search__close')) return;
    // expanded but not yet focused → focus
    if (!isFocused) focusInput();
  });

  /* ─────────────────────────────────────────────────────────────
     BLUR — restart typewriter if input empty
  ───────────────────────────────────────────────────────────── */
  input.addEventListener('blur', function () {
    if (input.value.trim() === '') {
      isFocused = false;
      input.classList.remove('nk-input-active');
      ghost.style.display = '';
      charIdx  = 0;
      isTyping = true;
      tick();
    }
  });

  /* ─────────────────────────────────────────────────────────────
     EXISTING: session-storage hidden state
  ───────────────────────────────────────────────────────────── */
  const STORAGE_KEY = 'nkFloatingSearchClosed';
  if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
    bar.classList.add('is-hidden');
  }

  /* ─────────────────────────────────────────────────────────────
     EXISTING: close button
  ───────────────────────────────────────────────────────────── */
  closeBtn.addEventListener('click', function () {
    bar.classList.add('is-hidden');
    sessionStorage.setItem(STORAGE_KEY, 'true');
    stopTW();
  });

  /* ─────────────────────────────────────────────────────────────
     EXISTING: focus shows bar (unchanged)
  ───────────────────────────────────────────────────────────── */
  input.addEventListener('focus', function () {
    bar.classList.remove('is-hidden');
  });

  /* ─────────────────────────────────────────────────────────────
     EXISTING: form submit with smart-search API (100% unchanged)
  ───────────────────────────────────────────────────────────── */
  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    const query = input.value.trim();
    if (!query) {
      input.focus();
      return;
    }
    try {
      form.classList.add('is-loading');
      const response = await fetch('https://57h1699t-8000.inc1.devtunnels.ms/designstudio/api/smart-search/', {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: query })
      });
      if (!response.ok) throw new Error(`Backend error: ${response.status}`);
      const rawText = await response.text();
      console.log('raw response text =', rawText);
      let data = {};
      try { data = rawText ? JSON.parse(rawText) : {}; }
      catch (err) { console.error('JSON parse failed:', err); }
      console.log('parsed data =', data);
      const redirectUrl = buildShopifySearchUrl(data, query);
      console.log('redirectUrl =', redirectUrl);
      setTimeout(() => { window.location.href = redirectUrl; }, 2000);
    } catch (error) {
      console.error('Floating smart search failed:', error);
      window.location.href = `/search?q=${encodeURIComponent(query)}`;
    } finally {
      form.classList.remove('is-loading');
    }
  });

  /* ─────────────────────────────────────────────────────────────
     EXISTING: filter helpers (100% unchanged)
  ───────────────────────────────────────────────────────────── */
  const FILTER_MAP = {
    occasion:   'filter.p.m.custom.filter_occasions',
    recipient:  'filter.p.m.custom.filter_recipient',
    age_group:  'filter.p.m.custom.filter_age_group',
    interests:  'filter.p.m.custom.filter_interests'
  };

  const FILTER_VALUE_MAP = {
    occasion:  { 'return gift': 'return-gift' },
    age_group: { kid: 'kids', child: 'kids' }
  };

  function normalizeFilterValue(key, value) {
    if (!value) return '';
    const normalized = String(value).trim().toLowerCase();
    const mapped = FILTER_VALUE_MAP[key]?.[normalized];
    return mapped || normalized;
  }

  function shouldApplyFilterValue(key, value) {
    if (!value) return false;
    const normalized = String(value).trim().toLowerCase();
    if (normalized === 'gift') return false;
    return true;
  }

  function buildShopifySearchUrl(data, originalQuery) {
    const params    = new URLSearchParams();
    const finalQuery = data?.search_text || originalQuery;
    params.set('q', finalQuery);
    params.set('options[prefix]', 'last');
    if (data?.filters && typeof data.filters === 'object') {
      Object.entries(data.filters).forEach(([key, values]) => {
        const param = FILTER_MAP[key];
        if (!param) return;
        const safeValues = Array.isArray(values) ? values : [values];
        safeValues.forEach((value) => {
          if (!shouldApplyFilterValue(key, value)) return;
          const normalizedValue = normalizeFilterValue(key, value);
          if (!normalizedValue) return;
          params.append(param, normalizedValue);
        });
      });
    }
    return `/search?${params.toString()}`;
  }

  /* ─────────────────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────────────────── */
  scheduleAutoExpand();

});